import css from 'styled-jsx/css';

export default css`.poster-name {
  vertical-align: middle; }

.articleCard-author-name {
  width: calc(100% - 23px);
  padding-left: 5px;
  overflow: hidden;
  height: 18px;
  line-height: 18px;
  vertical-align: middle;
  font-weight: 400; }
  .articleCard-author-name span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    height: 18px;
    color: rgba(0, 0, 0, 0.68);
    font-size: .8em;
    float: left; }

.userinfo-author-name {
  width: 100%;
  top: 50%;
  font-size: 1em;
  margin-left: 10px; }
  .userinfo-author-name.ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis; }
    .userinfo-author-name.ellipsis span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis; }
  .userinfo-author-name span.name {
    display: block;
    vertical-align: middle;
    font-size: 1.05em;
    line-height: 1.2em; }
  .userinfo-author-name span.loc, .userinfo-author-name span.locName, .userinfo-author-name span.des, .userinfo-author-name span.description {
    width: 100%; }
  .userinfo-author-name span.loc, .userinfo-author-name span.locName {
    display: block;
    font-size: .8em;
    color: #999;
    margin-top: 3px;
    line-height: 1.2em; }
  .userinfo-author-name span.des, .userinfo-author-name span.description {
    display: inline-block;
    font-size: .8em;
    color: #999;
    margin-top: 3px;
    line-height: 1.2em; }
`